import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private isMobileSidebarOpen = new BehaviorSubject<boolean>(false);
  public isMobileSidebarOpen$: Observable<boolean> = this.isMobileSidebarOpen.asObservable();

  constructor() { }

  toggleMobileSidebar(): void {
    this.isMobileSidebarOpen.next(!this.isMobileSidebarOpen.value);
  }

  openMobileSidebar(): void {
    this.isMobileSidebarOpen.next(true);
  }

  closeMobileSidebar(): void {
    this.isMobileSidebarOpen.next(false);
  }

  getMobileSidebarState(): boolean {
    return this.isMobileSidebarOpen.value;
  }
}

